import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
		path: '/newsDetails/:id',
		name: 'NewsDetails',
		component:() => import("@/views/newsDetails"),
		meta: {
			hidden: false
		},
	},
	{
		path: '/agreement/:type',
		name: 'Agreement',
		component: () => import("@/views/agreement"),  
		meta:{
			hidden: false
		},
	},
	{
		path: '*',
		name: '/Default',
		component: () => import("@/views/defaultPage"),  
		meta:{
			hidden: false
		},
  }
]

const router = new VueRouter({
	mode:'history',
	routes
})

export default router
